module.exports = __webpack_public_path__ + "static/media/15.011.4e1be7c1.webp";